import React, { useState } from "react";
import { useForm } from "react-hook-form";
import TextArea from "../components/common/TextArea";
import TextInput from "../components/common/TextInput";
import Modal from "../components/common/Model";
import Button from "../components/common/Button";
import { showError, showSuccess } from "../utils/helper";
import useLoader from "../hooks/useLoader";

import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";

import Footer from "../components/common/Footer";
import HeaderLogo from "../components/common/HeaderLogo";

const ContactUs = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fullName: "",
      email: "",
      phoneNumber: "",
      message: "",
    },
  });


const onSubmit = async (formData) => {
  try {
    setIsSubmitting(true)
    showLoader();

    // Prepare payload
    const payload = {
      name: formData.fullName,
      email: formData.email,
      message: formData.message,
    };

    // Call API using environment variable
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/support/submit`,
      payload
    );

    // Extract message from response
    const { message } = response.data;

    // Show success
    showSuccess(message || "Form submitted successfully!");
    setShowModal(true);
    reset();
  } catch (error) {
    console.error("Error submitting form:", error);
    showError("Failed to submit form. Please try again.");
  } finally {
    setIsSubmitting(false)
    hideLoader();
  }
};


  return (
    <div>
      <HeaderLogo/>
      <div className="mx-6 md:mx-12 mt-[10px] sm:mt-[10px] mb-[120px]">
        <p className="text-2xl font-bold font-helvetica">
          Get in touch with support team
        </p>
        {/* <p className="font-helvetica mt-1">Fill your form here</p> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
            <div className="flex flex-col justify-between">
              <div className="mb-4">
                <TextInput
                  placeholder="Enter your name"
                  type="text"
                  control={control}
                  label="Full Name"
                  name="fullName"
                  errors={errors}
                  rules={{ required: "Please enter your name" }}
                />
              </div>
              <div className="mb-2">
                <TextInput
                  placeholder="Enter your email address"
                  type="text"
                  name="email"
                  control={control}
                  errors={errors}
                  label="Email"
                  rules={{
                    required: "Please enter your email address",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Please enter a valid email address",
                    },
                  }}
                />
              </div>
            </div>
            <div className="mb-4 md:mb-0">
              <TextArea
                placeholder="Enter your message"
                type="text"
                control={control}
                label="Message"
                name="message"
                rows={5}
                errors={errors}
                rules={{ required: "Please enter your message" }}
                className={"!min-h-[140px]"}
              />
            </div>
          </div>
          <div className="flex md:justify-end space-x-4 mt-4 justify-center">
            <button
              type="button"
              onClick={() => reset()}
              className="px-6 py-2 !bg-[#7878801F] border !border-borderColor rounded-md text-gray-700 border-[#D0D5DD] hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 !bg-primary text-white rounded-md hover:bg-opacity-90"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <Modal open={showModal}  onClose={() => setShowModal(false)}>
        <div className="flex flex-col gap-4 items-center">
          <div className="text-[#2F39D3] ">
             <FaCheckCircle className="text-green-500 text-6xl" />
          </div>
          <h2 className="text-2xl font-semibold text-center">
            Submitted Successfully!
          </h2>
          <p className="text-center">
            Your request has been submitted successfully. We will get back to
            you shortly.
          </p>
          <Button
            onClick={() => setShowModal(false)}
            className=" !bg-primary text-white items-center md:w-18 justify-center focus:outline-none"
          >
            Ok
          </Button>
        </div>
      </Modal>
      <Footer/>
    </div>
  );
};

export default ContactUs;
